import { useMemo } from 'react';
import { AGGS_CARDS_WRAPPER } from './constants';
import AggregationCard from './AggregationCard';

const AggregationCardsContainer = ({
  modifier,
  items,
  urlTemplateToUse,
  overrideListingUrl,
  recordIds,
  brandNames
}) => {
  const parsedModifier = modifier ? ` ${modifier}` : '';
  const className = `${AGGS_CARDS_WRAPPER}${parsedModifier}`;

  // sort be name by default or id order if using random sort
  const sortedItems = useMemo(
    () =>
      !recordIds || !recordIds.length
        ? items.filter(Boolean).sort((a, b) => a.name.localeCompare(b.name))
        : recordIds.filter(Boolean).map(recordId => items.find(({ id }) => id === recordId)),
    [items, recordIds]
  );

  return (
    <div className={className}>
      {sortedItems.filter(Boolean).map(({ name, url: productTypeUrl, image } = {}) => (
        <AggregationCard
          name={name}
          urlTemplate={urlTemplateToUse}
          productTypeUrl={productTypeUrl}
          overrideListingUrl={overrideListingUrl}
          image={image}
          brandNames={brandNames}
        />
      ))}
    </div>
  );
};

export default AggregationCardsContainer;
